module.exports = new __parcel__URL__("jpd-portfolio-management-communicate-progress-dark.d0c6d635.svg").toString();